import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Aboutsection from '../components/Aboutsection';
const About = () => {
    return (
        <div>
            <Header />
            <Aboutsection />
            <Footer />
        </div>
    );
};

export default About;